export const formatCompactCountdown = (targetDate, now = new Date()) => {
  if (!targetDate) return '';
  const targetMs = new Date(targetDate).getTime();
  if (Number.isNaN(targetMs)) return '';

  const delta = targetMs - now.getTime();
  if (delta <= 0) return '0h';

  const totalHours = Math.floor(delta / (1000 * 60 * 60));
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;

  if (days > 0) return `${days}d`;
  if (hours > 0) return `${hours}h`;

  const minutes = Math.max(1, Math.floor(delta / (1000 * 60)));
  return `${minutes}m`;
};

export const formatDetailedCountdown = (targetDate, now = new Date()) => {
  if (!targetDate) return '';
  const targetMs = new Date(targetDate).getTime();
  if (Number.isNaN(targetMs)) return '';

  const delta = targetMs - now.getTime();
  if (delta <= 0) return '0h';

  const totalHours = Math.floor(delta / (1000 * 60 * 60));
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h`;

  const minutes = Math.max(1, Math.floor(delta / (1000 * 60)));
  return `${minutes}m`;
};

const DEFAULT_AVAILABILITY_COPY = Object.freeze({
  pending: 'Pending',
  inDuel: 'In Duel',
  available: 'Available',
});

export const getDuelAvailabilityLabel = (availability, now = new Date(), copy = DEFAULT_AVAILABILITY_COPY) => {
  if (!availability || availability.state === 'self') return '';
  if (availability.state === 'pending') return copy.pending || DEFAULT_AVAILABILITY_COPY.pending;
  if (availability.state === 'active') {
    const compact = formatCompactCountdown(availability.activeDuelEndsAt, now);
    return compact
      ? `${copy.inDuel || DEFAULT_AVAILABILITY_COPY.inDuel} ${compact}`
      : (copy.inDuel || DEFAULT_AVAILABILITY_COPY.inDuel);
  }
  return copy.available || DEFAULT_AVAILABILITY_COPY.available;
};

export const getDuelRecordLabel = (record) => {
  if (!record) return '0W-0L';
  return record.label || `${record.wins || 0}W-${record.losses || 0}L`;
};
